import AgeReportContainer from './age_report_container';

const AgeReport = AgeReportContainer;
export default AgeReport;
